var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import axios from 'axios';
import API_CONFIG from '@/config/api';
// Importamos el authService JS que contiene la lógica completa de tokens/refresh
import authService from '@/services/authService.js';
var axiosIns = axios.create({
    baseURL: API_CONFIG.BASE_URL,
    timeout: API_CONFIG.TIMEOUT,
    headers: API_CONFIG.DEFAULT_HEADERS
});
// Interceptor para agregar token JWT a las peticiones
axiosIns.interceptors.request.use(function (config) {
    var token = localStorage.getItem('token');
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = "Bearer ".concat(token);
    }
    return config;
}, function (error) { return Promise.reject(error); });
// Manejo de refresh token en respuestas 401/403
var refreshPromise = null;
axiosIns.interceptors.response.use(function (response) { return response; }, function (error) { return __awaiter(void 0, void 0, void 0, function () {
    var status, originalRequest, requestUrl, isAuthEndpoint, isRefreshEndpoint, currentRefreshToken, refreshError_1, newToken;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                console.error('Error en petición HTTP:', error);
                status = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status;
                originalRequest = error.config || {};
                requestUrl = originalRequest.url || '';
                isAuthEndpoint = requestUrl.includes('/auth/');
                isRefreshEndpoint = requestUrl.includes('/auth/refresh');
                if (!((status === 401 || status === 403) && !isAuthEndpoint && !isRefreshEndpoint)) return [3 /*break*/, 5];
                // Evitar bucles de reintentos
                if (originalRequest._retry) {
                    return [2 /*return*/, Promise.reject(error)];
                }
                originalRequest._retry = true;
                currentRefreshToken = (_b = authService.getRefreshToken) === null || _b === void 0 ? void 0 : _b.call(authService);
                if (!currentRefreshToken) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('user');
                    localStorage.removeItem('refreshToken');
                    window.location.href = '/gestioncomercial/login';
                    return [2 /*return*/, Promise.reject(error)];
                }
                if (!refreshPromise) {
                    refreshPromise = authService
                        .refreshAccessToken()
                        .catch(function (err) {
                        localStorage.removeItem('token');
                        localStorage.removeItem('user');
                        localStorage.removeItem('refreshToken');
                        window.location.href = '/gestioncomercial/login';
                        throw err;
                    })
                        .finally(function () {
                        refreshPromise = null;
                    });
                }
                _d.label = 1;
            case 1:
                _d.trys.push([1, 3, , 4]);
                return [4 /*yield*/, refreshPromise];
            case 2:
                _d.sent();
                return [3 /*break*/, 4];
            case 3:
                refreshError_1 = _d.sent();
                return [2 /*return*/, Promise.reject(refreshError_1)];
            case 4:
                newToken = (_c = authService.getToken) === null || _c === void 0 ? void 0 : _c.call(authService);
                if (newToken) {
                    originalRequest.headers = originalRequest.headers || {};
                    originalRequest.headers.Authorization = "Bearer ".concat(newToken);
                }
                return [2 /*return*/, axiosIns(originalRequest)];
            case 5:
                // Si falla el refresh (401/403 en /auth/refresh), cerrar sesión para evitar bucle
                if ((status === 401 || status === 403) && isRefreshEndpoint) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('user');
                    localStorage.removeItem('refreshToken');
                    window.location.href = '/gestioncomercial/login';
                    return [2 /*return*/, Promise.reject(error)];
                }
                return [2 /*return*/, Promise.reject(error)];
        }
    });
}); });
// Registrar axios en Vue para compatibilidad
Vue.prototype.$http = axiosIns;
export default axiosIns;
